import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CrossSellingState } from './cross-selling.state';

export const selectCrossSelling = createFeatureSelector<CrossSellingState>('crossSelling');

export const selectCrossSellingState = createSelector(
  selectCrossSelling,
  (state: CrossSellingState) => state.CrossSelling
);
